<template>
    <div class="d-flex flex-row justify-content-center align-items-center page-header">
        <h2 class="page-header-txt"><slot></slot></h2>
    </div>
</template>

<script>
export default {
  name: 'PageHeader',
}
</script>